import { Pipe, PipeTransform } from '@angular/core';
import '@extensions/string.extensions';
import { LabelsDataService } from '@services/labels-data.service';

@Pipe({ standalone: false, name: 'labelText' })
export class LabelTextPipe implements PipeTransform {
  constructor(private labelsDataService: LabelsDataService) {}

  transform(labelKey: string, ...replacements: any[]): string {
    if (!labelKey) {
      return '';
    }

    try {
      const label = this.labelsDataService.getData(labelKey) + '';
      return label.myFormatString(replacements);
    } catch {
      return 'LABEL_ERROR';
    }
  }
}
